// __UNIT_DOWNTIME__ + __SELF_UNLOAD__ (2026-10-08) pure helpers for two things kept in Settings >
// Equipment rules (public.equipment_rules row 'main', data) -- no new table or column, so nothing waits
// on a migration:
//   - a dated maintenance / out-of-service / time-off schedule per truck or trailer = a unit restriction
//     'unavailable' with start / end (inclusive) and a kind. The job check warns on those days
//     ('unit_restricted') and the hub's booking availability counts the unit as out.
//   - per driver "Can self-unload (operate on-site equipment)" = driver_caps[driverId].can_self_unload.
// Edited in Trucks / Trailers (Edit), the Equipment Assignment view and Drivers. Tests: sim/equipment.test.mjs.
import { normalizeRules, DOWNTIME_KINDS } from './equipmentCompat';

const isDay = (s) => /^\d{4}-\d{2}-\d{2}$/.test(String(s || ''));

// every dated downtime, or those of one unit, earliest first
export function downtimeOf(rules, unitKind, unitId) {
  const R = normalizeRules(rules);
  return R.restrictions
    .filter((x) => x.field === 'unavailable' && (!unitKind || (x.unit_kind === unitKind && x.unit_id === String(unitId))))
    .sort((a, b) => (a.start < b.start ? -1 : a.start > b.start ? 1 : 0));
}

// -> { rules } or { error }
export function addDowntime(rules, { unitKind, unitId, start, end, kind, note, id } = {}) {
  if (unitKind !== 'truck' && unitKind !== 'trailer') return { error: 'Pick a truck or trailer.' };
  if (!unitId) return { error: 'Pick a truck or trailer.' };
  if (!isDay(start)) return { error: 'Give the first day.' };
  if (end && !isDay(end)) return { error: 'The last day is not a date.' };
  if (end && end < start) return { error: 'The last day is before the first.' };
  const k = Object.prototype.hasOwnProperty.call(DOWNTIME_KINDS, kind) ? kind : 'maintenance';
  const R = normalizeRules(rules);
  const rid = id || ('dt' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6));
  const next = { ...R, restrictions: [...R.restrictions, { id: rid, field: 'unavailable', value: true, start, end: end || null,
    note: String(note || '').trim(), unit_kind: unitKind, unit_id: String(unitId), kind: k }] };
  return { rules: normalizeRules(next), id: rid };
}

export function removeDowntime(rules, id) {
  const R = normalizeRules(rules);
  return normalizeRules({ ...R, restrictions: R.restrictions.filter((x) => x.id !== id) });
}

export function setDriverSelfUnload(rules, driverId, can) {
  const R = normalizeRules(rules);
  const caps = { ...R.driver_caps };
  if (can) caps[String(driverId)] = { can_self_unload: true };
  else delete caps[String(driverId)];
  return normalizeRules({ ...R, driver_caps: caps });
}

export const downtimeText = (x) => (DOWNTIME_KINDS[x.kind] || 'unavailable') + ': ' + x.start + (x.end ? (x.end !== x.start ? ' to ' + x.end : '') : ' onward')
  + (x.note ? ' - ' + x.note : '');
